import styled from 'styled-components';
import { Link } from "react-router-dom";
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  top: -5px;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Description = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  color: ${colors.silver};
  margin-bottom: 25px;
`;

export const Title = styled.span`
  color: ${colors.white};
  font-size: 16px;
  font-weight: bold;
`;

export const SettingLink = styled(Link)`
  color: ${colors.lightBlue};
  font-size: 16px;
  margin-left: 10px;
  text-decoration: none;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin-top: 15px;
    margin-bottom: 10px;
    color: ${colors.white};

    span {
      font-weight: 300;
    }
  }
`;

export const Footer = styled.div`
  font-weight: 300;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 12px;

  .select {
      background-position: 90% 50%;
      background-size: 15px 15px;
  }
`;
